<template>
  <div class="layout" :class="{layout_mobile: is_mobile_size}">
    <div class="layout__menu-top">
      <div class="menu-top">
        <div class="menu-top__burger" @click="toggleMenu" :class="{'menu-top__burger_active' : is_menu_opened}">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <a href="https://buzzoola.com/ru/" class="menu-top__logo-link">
          <img class="menu-top__logo" alt='buzz logo' src='@/assets/logo.svg'>
        </a>
      </div>
    </div>
    <div class="layout__left" :class="{layout__left_active: is_menu_opened}">
      <div class="layout__menu">
        <div class="layout__menu-nav">
          <doc-menu :doc_id="doc_id" :req_id="req_id" v-model="is_menu_opened"></doc-menu>
        </div>
      </div>
    </div>
    <div class="layout__right">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
import docMenu from '@/components/documentation/menu.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'documentationLayout',
  props: {
    doc_id: {
      type: String,
    },
    req_id: {
      type: String,
      default: '',
    },
  },
  components: {
    docMenu,
  },
  data() {
    return {
      is_mobile_device: isMobile,
      is_mobile_size: isMobile,
      is_menu_opened: false,
    };
  },
  methods: {
    toggleMenu() {
      this.is_menu_opened = !this.is_menu_opened;
    },
    resizeHandler() {
      if (window.innerWidth < 1000) {
        this.is_mobile_size = true;
      } else {
        this.is_mobile_size = isMobile;
      }
    },
  },
  created() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style scoped lang='stylus'>
@import '../../styles/main.styl'

.layout
  position absolute
  left 0
  top 0
  width 100%
  height 100%
  display flex
  align-items stretch
  &__right
    position relative
    display flex
    align-items flex-start
    justify-content center
    width 100%
    max-height 100%
    overflow auto
    padding 20px
    box-sizing border-box
    ^[0]_mobile &
      margin-top 53px
      max-height calc(100% - 53px)
  &__left
    position relative
    flex-shrink 0
    width 360px
    height 100%
    padding 20px
    box-sizing border-box
    background-color white
    ^[0]_mobile &
      position absolute
      z-index 10
      width 100%
      transform translateX(-100%)
      padding 15px 20px 20px
      &_active
        transition transform .2s ease-in-out
        transform translateX(0)
  &__menu-top
    position absolute
    z-index 12
    left 20px
    top 20px
    ^[0]_mobile &
      position fixed
      width 100%
      top 0
      left 0
      z-index 12
      background white
      border 1px solid #e6e6e6
      box-sizing border-box
  &__menu
    padding-top 40px
    height calc(100% - 40px)
    &-nav
      box-sizing border-box
      padding 40px 0 20px
      height 100%
    &-wrap
      height calc(100% - 280px)
      ^[0]_mobile &
        height calc(100% - 230px)
    &-btn-wrap
      position absolute
      bottom 10px
      left 20px
      width 320px
      display flex
      align-items center
      flex-direction column
      ^[0]_mobile &
        width calc(100% - 40px)
    &-btn
      width 100%
      margin-top 10px
      padding 12px
      text-align center
      text-decoration none
      font-size 14px
      line-height 16px
      font-family 'Roboto', sans-serif
      font-weight 500
      color #f50
      border-radius 8px
      border 1px solid #cfdae6
      box-sizing border-box
      -webkit-tap-highlight-color transparent
      text-decoration none
      +hover()
        &:hover
          background-color #f50
          color #fff
          cursor pointer
          border 1px solid #f50

.menu-top
  position relative
  .layout_mobile &
    padding 10px 20px
  &__logo
    width 170px
    height auto
    display block
    text-decoration none
    outline none
    border none
    .layout_mobile &
      width 130px
    &-link
      text-decoration none
      outline none
      border none
      width auto
      display inline-block
  &__burger
    display none
    position absolute
    top 10px
    right 20px
    width 25px
    height 30px
    box-sizing border-box
    cursor pointer
    .layout_mobile &
      display flex
      flex-direction column
      justify-content space-evenly
    & span
      width 100%
      height 1px
      background black
      border-radius 4px
      transition opacity, transform .3s linear
    &_active span
      &:nth-child(1)
        transform translateY(7px) rotate(45deg)
      &:nth-child(2)
        opacity 0
      &:nth-child(3)
        transform translateY(-8px) rotate(-45deg)

</style>
